interface ISection {
  textAlign: string;
  flexDir?: string;
  textWidth?: string;
  heading: string;
  headingAlign: "start" | "center" | "end";
  blockText: Array<String>;
  imgUrl?: string;
  imgAlt?: string;
}

type TFeaturesList = {
  iconUrl: string;
  iconText?: string;
  iconAlt?: string;
  iconTitle?: string;
};

interface IFeaturesList {
  flexDir: "row" | "column";
  featuresArray: Array<TFeaturesList>;
}

type ServicesCardInfo = {
  cardImgUrl: string;
  cardImgAlt: string;
  cardTitle: string;
  cardText: string;
};

interface ServicesCardList {
  servicesArray: Array<ServicesCardInfo>;
}

type ClientProps = {
  clientImg: string;
  clientTitle: string;
  clientText: string;
  clientService: string;
};

export const sectionOne: ISection = {
  textAlign: "center",
  flexDir: "column",
  textWidth: "800px",
  heading: "Software que entiende cómo trabaja tu empresa",
  headingAlign: "center",
  blockText: [
    "Creamos sistemas pensados para operaciones reales: facturación, stock, clientes, proveedores, reportes y portales de autogestión. No partimos de una plantilla cerrada; primero entendemos cómo trabaja tu equipo y después diseñamos una herramienta que encaje con tus procesos.",
  ],
};

export const sectionTwo: ISection = {
  textAlign: "start",
  flexDir: "column",
  textWidth: "415px",
  heading: "¿Quiénes somos?",
  headingAlign: "start",
  blockText: [
    "BI Consulting es una empresa de desarrollo de software con sede en Lobos, Buenos Aires. Desde 1986 acompañamos a empresas que necesitan ordenar su operación diaria, reducir tareas manuales y conectar mejor la información entre administración, clientes y gestión interna.",
    "Trabajamos con una lógica simple: entender primero, desarrollar después. Relevamos tus procesos, detectamos puntos de fricción y construimos sistemas que el equipo pueda adoptar con confianza, sin romper la forma en que la empresa ya funciona.",
  ],
  imgUrl: "/assets/images/office-worker-desktop.jpg",
  imgAlt:
    "Persona trabajando en una oficina con una computadora y una taza de café",
};

export const featuresList: IFeaturesList = {
  flexDir: "row",
  featuresArray: [
    {
      iconUrl: "/assets/images/hand-holding-heart-solid.svg",
      iconAlt: "Ícono de acompañamiento",
      iconText: "+30 años de experiencia",
    },
    {
      iconUrl: "/assets/images/cloud-solid-full.svg",
      iconAlt: "Ícono de nube",
      iconText: "Gestión local y en la nube",
    },
    {
      iconUrl: "/assets/images/rocket-solid.svg",
      iconAlt: "Ícono de mejora operativa",
      iconText: "Menos tareas manuales",
    },
  ],
};

export const servicesList: ServicesCardList = {
  servicesArray: [
    {
      cardImgUrl: "/assets/images/firmware-rafiki.svg",
      cardImgAlt:
        "Ilustración de una persona trabajando con herramientas digitales",
      cardTitle: "Gestión administrativa",
      cardText:
        "Un sistema que centraliza facturación, stock y pedidos. Tu equipo deja de perseguir información en planillas sueltas y gana control real sobre la operación diaria.",
    },
    {
      cardImgUrl: "/assets/images/firmware-cuate.svg",
      cardImgAlt: "Ilustración de una persona trabajando en una oficina",
      cardTitle: "Portal de autogestión",
      cardText:
        "Tus clientes consultan facturas, pagos y documentación sin llamar a nadie. Menos consultas repetitivas, más tiempo para lo que importa.",
    },
    {
      cardImgUrl: "/assets/images/version-control-bro.svg",
      cardImgAlt: "Ilustración de un desarrollador trabajando",
      cardTitle: "Software a medida",
      cardText:
        "Cuando lo estándar no alcanza, construimos el sistema que tu operación necesita: integra procesos, reemplaza planillas y conecta las herramientas que ya usás.",
    },
  ],
};

export const ourTechsList: IFeaturesList = {
  flexDir: "row",
  featuresArray: [
    {
      iconUrl: "/assets/images/microsoft.svg",
      iconAlt: "Logo de Microsoft",
      iconTitle: "Microsoft",
    },
    {
      iconUrl: "/assets/images/vscode.svg",
      iconAlt: "Logo de Visual Studio",
      iconTitle: "Visual Studio",
    },
    {
      iconUrl: "/assets/images/dotnet.svg",
      iconAlt: "Logo de Microsoft .NET",
      iconTitle: "Microsoft .NET",
    },
    {
      iconUrl: "/assets/images/mssql.svg",
      iconAlt: "Logo de Microsoft SQL Server",
      iconTitle: "Microsoft SQL Server",
    },
    {
      iconUrl: "/assets/images/docker-mark-ocean-blue.svg",
      iconAlt: "Logo de Docker",
      iconTitle: "Docker",
    },
  ],
};

export const clientsList: Array<ClientProps> = [
  {
    clientImg: "assets/images/arcor90x90.png",
    clientTitle: "Arcor",
    clientText:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    clientService: "Servicio brindado 1",
  },
  {
    clientImg: "assets/images/translorenzetti-logo-black.png",
    clientTitle: "Transporte Lorenzetti",
    clientText:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    clientService: "Servicio brindado 2",
  },
  {
    clientImg: "assets/images/translorenzetti-logo-black.png",
    clientTitle: "Otro Cliente",
    clientText:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    clientService: "Servicio brindado 3",
  },
];
